function convert(value = []) {
    return !ArrayBuffer.isView(value) && value ? Float64Array.from(value) : value;
}
export function convertDataToFloat64Array(data) {
    return {
        x: convert(data.x),
        re: convert(data.re),
        im: convert(data?.im),
    };
}
